import { startCase } from 'lodash';
import { FIELD_LABELS } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/constants/wizardFieldLabels';
import { getWizardValidationGuidance } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/utils/wizardValidationGuidance';

// Entry shape: { field: camelCase string | null, message: string, messageType: 'Error' | 'Warning' | 'WarningWithConfirmation' }
const hasMessageType = (entry, type) => entry?.messageType?.toLowerCase() === type;

const isRequiredMessage = (message) => /required/i.test(message ?? '');

const issueKey = (entry) => `${entry.field}|${entry.message}|${entry.messageType}`;

const getFieldLabel = (field) => FIELD_LABELS[field] ?? startCase(field);

const toIssue = (entry) => {
  const { field, message } = entry;

  if (!field) {
    return { key: issueKey(entry), field: null, label: 'Product data', description: message, detail: null };
  }

  return {
    key: issueKey(entry),
    field,
    label: getFieldLabel(field),
    description: getWizardValidationGuidance(field),
    detail: isRequiredMessage(message) ? null : message,
  };
};

const uniqueEntries = (validationErrors) => [
  ...new Map((validationErrors ?? []).map((entry) => [issueKey(entry), entry])).values(),
];

export const buildValidationIssues = (validationErrors) => {
  const entries = uniqueEntries(validationErrors);
  return {
    errors: entries.filter((entry) => hasMessageType(entry, 'error')).map(toIssue),
    warnings: entries.filter((entry) => hasMessageType(entry, 'warning')).map(toIssue),
    confirmations: entries
      .filter((entry) => hasMessageType(entry, 'warningwithconfirmation'))
      .map(toIssue),
  };
};
